import {Nullish} from 'utility-types';

export const isUnsupportedCombination = (
  showStockCars: boolean | Nullish,
  showSoldIn30: boolean | Nullish,
  showSoldIn90: boolean | Nullish
) => !!showStockCars && !showSoldIn30 && !!showSoldIn90;
